<template>
  <div>
    <my-asidebar v-bind:active-tab="'cruise'"> </my-asidebar>
<!--    -->
    <section class="dashboard-area">
      <top-bar></top-bar>
      <div class="dashboard-content-wrap">
        <div class="dashboard-bread dashboard--bread dashboard-bread-2">
          <div class="container-fluid">
            <div class="row align-items-center">
              <div class="col-lg-6">
                <div class="breadcrumb-content">
                  <div class="section-heading">
                    <h2 class="sec__title font-size-30 text-white">Cruise</h2>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="breadcrumb-list text-right">
                  <ul class="list-items">
                    <li><a :href="basePath" class="text-white">Anasayfa</a></li>
                    <li>Cruise List</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <cruise-list></cruise-list>
      </div>
    </section>
  </div>
</template>

<script>

import CruiseList from "../component/cruise/CruiseList";
import TopBar from "../component/common/TopBar";
import MyAsidebar from "../component/common/MyAsidebar";

export default {
  name: "CruiseListPage",
  components: {MyAsidebar, TopBar, CruiseList},
  computed:{
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    },
    panelRights:{
      get(){
        return this.$store.getters.getPanelRightsMap;
      }
    }
  },
  mounted() {
    if(!this.panelRights["PANEL_PAGE_CRUISE_LIST"]) this.$router.push("/");

    this.$store.dispatch("loadCruiseList");
  }
}
</script>

<style scoped>

</style>